import React, { useState, useEffect, useRef, useCallback } from "react";
import "react-datetime/css/react-datetime.css";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { Checkbox } from "@material-ui/core";
import styled from "styled-components";
import {
	Card,
	Modal,
	Form,
	Table,
	Row,
	Col,
	Button,
	Spinner,
	Pagination,
	Tabs,
	Tab,
	Image,
} from "react-bootstrap";
import {
	AddCircle,
	Delete,
	Edit,
	Photo,
	Visibility,
	VisibilityOff,
} from "@material-ui/icons";
import UploadService from "../../services/FileUploadService";
import "react-datetime/css/react-datetime.css";
import {
	getPromotionProducts,
	searchProduct,
	getBrands,
	getCategory,
	getSubCategory,
	getSuppliers,
	getSubCategoryMap,
	uploadPromotion,
	getAdminProductsSaleCampaign,
	getAllAdminSaleCampaigns,
	updateAdminProductsSaleCampaign,
	deleteAdminProductsSaleCampaign,
	createAdminProductsSaleCampaign,
	updateAdminSaleCampaign,
	addAdminProductsSaleCampaign,
	createdAminSaleCampaign,
	deleteAdminSaleCampaign,
} from "../../store/actions/dashboardAction";
import moment from "moment";
const PromotionCampaigns = (props) => {
	let admin = localStorage.getItem("admin");
	if (!admin) window.location.href = "/";

	const [showEditCampaignFormModal, setShowEditCampaignFormModal] =
		useState(false);
	const [showImage, setShowImage] = useState(false);
	const [imgUrl, setImgUrl] = useState("");

	const [productIDS, setProductIDs] = useState([]);

	const [campaignPage, setCampaignPage] = useState(1);
	const [promoPage, setPromoPage] = useState(1);

	const _mobileBannerFileRef = useRef(null);
	const _webBannerFileRef = useRef(null);
	const _campaignIconRef = useRef(null);

	const [campaign, setCampaign] = useState({});
	const [campaignName, setCampaignName] = useState("");
	const [promotionType, setPromotionType] = useState(null);
	// const [campaignRefId, setCampaignRefId] = useState("");
	const [banner, setBanner] = useState({ mobile: "", web: "" });
	const [icon, setIcon] = useState("");
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [displayAhead, setDisplayAhead] = useState("");

	const [search, setSearch] = useState("");
	const [searchPromo, setSearchPromo] = useState("");

	const [filterActive, setFilterActive] = useState("");
	const [filterStatus, setFilterStatus] = useState("");

	const [openNewCampaignModal, setOpenNewCampaignModal] = useState(false);
	const [createProductsCampaignMode, setCreateProductCampaignMode] =
		useState(false);
	const [addProductMode, setAddProductMode] = useState(false);
	const [infosEditMode, setInfosEditMode] = useState(false);
	const [bannerEditMode, setBannerEditMode] = useState(false);
	const [bannerLoading, setBannerLoading] = useState({
		icon: false,
		mobile: false,
		web: false,
	});

	const [isChanged, setIsChanged] = useState({
		name: false,
		type: false,
		display_ahead: false,
		start_date: false,
		end_date: false,
	});

	const [isSubmitted, setIsSubmitted] = useState(false);

	const promotionTypes = [
		{ label: "Promotion", value: 0 },
		{ label: "Black Friday", value: 1 },
	];

	const activeFilters = [
		{ label: "All", value: "" },
		{ label: "Active", value: 1 },
		{ label: "Inactive", value: 0 },
	];
	const statusFilters = [
		{ label: "All", value: "" },
		{ label: "Valid", value: 1 },
		{ label: "Expired", value: 0 },
	];

	// form error
	const [formError, setFormError] = useState({
		name: "",
		type: "",
		display_ahead: "",
		start_date: "",
		end_date: "",
		wrong_date: "",
		product_ids: "",
	});

	const validateForm = (type, target) => {
		let tmpFormError = {
			name: "",
			type: "",
			display_ahead: "",
			start_date: "",
			end_date: "",
			wrong_date: "",
			// product_ids: "",
		};

		switch (type) {
			case "campaign":
				switch (target) {
					case "create":
						if (campaignName === "") tmpFormError.name = "is required.";
						if (promotionType === "") tmpFormError.type = "is required.";
						break;
					case "update":
						if (campaignName === "") tmpFormError.name = "is required.";
						if (promotionType === "") tmpFormError.type = "is required.";
						if (displayAhead === "") tmpFormError.display_ahead = "is required.";
						if (!startDate) tmpFormError.start_date = "is required.";
						if (!endDate) tmpFormError.end_date = "is required.";
						if (moment(endDate).isSameOrBefore(moment(startDate)))
							tmpFormError.wrong_date = "End Date must greater than Start Date.";
						break;
					default:
						break;
				}
				break;
			case "products":
				switch (target) {
					case "create":
						if (!displayAhead) tmpFormError.display_ahead = "is required.";
						if (!startDate) tmpFormError.start_date = "is required.";
						if (!endDate) tmpFormError.end_date = "is required.";
						if (moment(endDate).isSameOrBefore(moment(startDate)))
							tmpFormError.wrong_date = "End Date must greater than Start Date.";
						// if (!promoProductIDs.length)
						// 	tmpFormError.product_ids = "Please select some products!";
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}

		if (Object.values(tmpFormError).every((el) => el === "")) {
			return true;
		} else {
			setFormError({
				name: tmpFormError.name,
				type: tmpFormError.type,
				display_ahead: tmpFormError.display_ahead,
				start_date: tmpFormError.start_date,
				end_date: tmpFormError.end_date,
				// product_ids: tmpFormError.product_ids,
			});
			return false;
		}
	};

	//handle image open
	const handleShowImageOpen = (url) => {
		setImgUrl(url);
		setShowImage(true);
	};

	const handleShowImageClose = (url) => {
		setImgUrl(url);
		setShowImage(false);
	};

	//handle Open Edit campaign modal
	const handleOpenEditCampaignFormModal = (campaign) => {
		setShowEditCampaignFormModal(true);

		setCampaign(campaign);
		setCampaignName(campaign?.name);
		// setCampaignRefId(campaign?.name_ref_id);
		setPromotionType(
			campaign?.name_ref_id?.toLowerCase().match(/black-friday/g) ? 1 : 0
		);
		setIcon(campaign.icon ? campaign.icon : "");
		setBanner(campaign.banner ? JSON.parse(campaign.banner) : "");
		setDisplayAhead(campaign?.sale_promotion_campaign_product?.display_ahead);
		setStartDate(campaign?.sale_promotion_campaign_product?.start_date);
		setEndDate(campaign?.sale_promotion_campaign_product?.end_date);
	};

	//handle close Add campaign Modal
	const handleCloseEditCampaignFormModal = () => {
		setShowEditCampaignFormModal(false);
		setCreateProductCampaignMode(false);
		setAddProductMode(false);
		setInfosEditMode(false);
		setBannerEditMode(false);
		setCampaignPage(1);
		setPromoPage(1);
		setSearch("");
		setSearchPromo("");
		setProductIDs([]);
		setIsChanged({
			name: false,
			type: false,
			display_ahead: false,
			start_date: false,
			end_date: false,
		});
		setFormError({
			name: "",
			type: "",
			start_date: "",
			end_date: "",
			wrong_date: "",
			product_ids: "",
		});
	};

	const handleChangeCampaignPage = (target) => {
		switch (target) {
			case "first":
				setCampaignPage((current) => {
					if (current === 1) return current;
					return 1;
				});
				break;
			case "back":
				setCampaignPage((current) => {
					if (current === 1) return current;
					return current - 1;
				});
				break;
			case "next":
				setCampaignPage((current) => {
					if (current === props?.campaign_products?.totalPages) return current;
					return current + 1;
				});
				break;
			case "last":
				setCampaignPage((current) => {
					if (current === props?.campaign_products?.totalPages) return current;
					return props?.campaign_products?.totalPages;
				});
				break;
			default:
				break;
		}
	};

	const handleChangePromoPage = (target) => {
		switch (target) {
			case "first":
				setPromoPage((current) => {
					if (current === 1) return current;
					return 1;
				});
				break;
			case "back":
				setPromoPage((current) => {
					if (current === 1) return current;
					return current - 1;
				});
				break;
			case "next":
				setPromoPage((current) => {
					if (current === props?.promo_products?.total_page) return current;
					return current + 1;
				});
				break;
			case "last":
				setPromoPage((current) => {
					if (current === props?.promo_products?.total_page) return current;
					return props?.promo_products?.total_page;
				});
				break;
			default:
				break;
		}
	};

	const handleChangeCampaignFilter = (e, type) => {
		let { value } = e.target;
		switch (type) {
			case "active":
				setFilterActive(value);
				break;
			case "status":
				setFilterStatus(value);
				break;
			default:
				break;
		}
	};

	const handleCancelEdit = (type) => {
		if (type === "infos") {
			setInfosEditMode(false);
			setCampaignName(campaign?.name);
			// setCampaignRefId(campaign?.name_ref_id);
			setPromotionType(
				campaign?.name_ref_id?.toLowerCase().match(/black-friday/g) ? 1 : 0
			);
			setDisplayAhead(campaign?.sale_promotion_campaign_product?.display_ahead);
			setStartDate(campaign?.sale_promotion_campaign_product?.start_date);
			setEndDate(campaign?.sale_promotion_campaign_product?.end_date);
			setIsChanged({
				name: false,
				type: false,
				display_ahead: false,
				start_date: false,
				end_date: false,
			});
			setFormError({
				name: "",
				type: "",
				start_date: "",
				end_date: "",
				wrong_date: "",
				product_ids: "",
			});
		} else {
			setBannerEditMode(false);
			setIcon(campaign?.icon);
			setBanner(JSON.parse(campaign?.banner));
		}
	};

	const handleChangeCampaignName = (e) => {
		const { value } = e.target;
		setIsChanged({ ...isChanged, name: true });
		if (!value) {
			setFormError({ ...formError, name: "is required." });
		} else {
			setFormError({ ...formError, name: "" });
		}
		setCampaignName(value);
		// let nameRefId = value
		// 	.replace(/[\u0300-\u036f]/g, "")
		// 	.replace(/\s+/g, "-")
		// 	.toLowerCase()
		// 	.replace(/&/g, "-and-")
		// 	.replace(/[^a-z0-9\-]/g, "")
		// 	.replace(/-+/g, "-")
		// 	.replace(/^-*/, "")
		// 	.replace(/-*$/, "");
		// setCampaignRefId(nameRefId);
	};

	const handleChangePromotionType = (e) => {
		const { value } = e.target;
		setIsChanged({ ...isChanged, type: true });
		if (!value) {
			setFormError({ ...formError, type: "is required." });
		} else {
			setFormError({ ...formError, type: "" });
		}
		setPromotionType(parseInt(value));
	};

	const handleChangeDisplayAhead = (e) => {
		const { value } = e.target;
		setIsChanged({ ...isChanged, display_ahead: true });
		if (!value) {
			setFormError({ ...formError, display_ahead: "is required." });
		} else if (parseInt(value) === 0) {
			setFormError({ ...formError, display_ahead: "must grater than 0." });
		} else {
			setFormError({ ...formError, display_ahead: "" });
		}
		setDisplayAhead(parseFloat(value));
	};

	const handleChangeDate = (e, type) => {
		const date = e.target.value;
		switch (type) {
			case "start": {
				setStartDate(date);
				setIsChanged({ ...isChanged, start_date: true });
				break;
			}
			case "end": {
				setEndDate(date);
				setIsChanged({ ...isChanged, end_date: true });
				break;
			}
			default:
				break;
		}
	};

	const handleChangeBanner = async (type) => {
		try {
			let formData = null;
			switch (type) {
				case "icon":
					if (_campaignIconRef.current !== null) {
						setBannerLoading({ ...bannerLoading, icon: true });
						formData = new FormData();
						formData.append("image", _campaignIconRef.current.files[0]);
					}
					break;
				case "mobile":
					if (_mobileBannerFileRef.current !== null) {
						setBannerLoading({ ...bannerLoading, mobile: true });
						formData = new FormData();
						formData.append("image", _mobileBannerFileRef.current.files[0]);
					}
					break;
				case "web":
					if (_webBannerFileRef.current !== null) {
						setBannerLoading({ ...bannerLoading, web: true });
						formData = new FormData();
						formData.append("image", _webBannerFileRef.current.files[0]);
					}
					break;
				default:
					break;
			}
			if (formData) {
				await UploadService.uploadImageFromDashboard(formData).then((response) => {
					if (response.data.success && response.data.data.length) {
						if (type === "mobile") {
							setBannerLoading({ ...bannerLoading, mobile: false });
							setBanner({ ...banner, mobile: response.data.data[0].url });
						} else if (type === "icon") {
							setBannerLoading({ ...bannerLoading, icon: false });
							setIcon(response.data.data[0].url);
						} else {
							setBannerLoading({ ...bannerLoading, web: false });
							setBanner({ ...banner, web: response.data.data[0].url });
						}
					}
				});
			}
		} catch (e) {
			console.log("Debug: ", e);
			setBannerLoading({ icon: false, mobile: false, web: false });
			// handleShowToast("ERROR", "Upload Icon failed");
		}
	};

	const handleSubmitUpdateCampaign = (type) => {
		if (type === "infos") {
			if (!validateForm("campaign", "update")) return;
			setInfosEditMode(false);
			let updateQuery = {
				campaign_id: campaign?.campaign_id,
				// name: campaignName,
				// type: promotionType,
				display_ahead: displayAhead,
				start_date: moment(startDate),
				end_date: moment(endDate),
			};

			if (
				campaignName !== campaign?.name ||
				promotionType !== campaign?.is_black_friday
			) {
				props.updateAdminSaleCampaign({
					campaign_id: campaign?.campaign_id,
					name: campaignName,
					type: promotionType,
				});
			}
			props.updateAdminProductsSaleCampaign(updateQuery);
			setIsChanged({
				name: false,
				type: false,
				display_ahead: false,
				start_date: false,
				end_date: false,
			});
			setFormError({
				name: "",
				display_ahead: "",
				start_date: "",
				end_date: "",
				wrong_date: "",
				product_ids: "",
			});
		} else {
			setBannerEditMode(false);
			props.updateAdminSaleCampaign({
				campaign_id: campaign?.campaign_id,
				banner: JSON.stringify(banner),
				icon: icon,
			});
		}
	};

	const handleDeleteCampaignProduct = (itemIds) => {
		props.deleteAdminProductsSaleCampaign({
			campaign_id: campaign?.campaign_id,
			product_ids: itemIds,
			page: addProductMode ? null : 1,
			limit: addProductMode ? null : 10,
		});

		let timeout = setTimeout(() => {
			setProductIDs([]);
			if (campaignPage > 1) {
				setCampaignPage(1);
			}
		}, 500);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handleAddCampaignProduct = (itemIds) => {
		props.addAdminProductsSaleCampaign({
			campaign_id: campaign?.campaign_id,
			product_ids: itemIds,
		});
	};

	const handleEnableCampaign = (campaignId, status) => {
		if (
			status === 0 &&
			props?.campaigns?.find((campaign) => parseInt(campaign.is_disabled) === 0)
		) {
			window.alert(
				"Cannot enable the campaign! There is another campaign is being activating."
			);
			return;
		}

		if (
			!window.confirm(
				`Do you wish to ${status === 1 ? "deactivate" : "activate"} this campaign?`
			)
		)
			return;
		props.updateAdminSaleCampaign({
			campaign_id: campaignId,
			is_disabled: status,
		});
	};

	const handleToggleCrateNewCampaign = () => {
		setOpenNewCampaignModal((prev) => !prev);
		setBanner({ mobile: "", web: "" });
		setIcon("");
		setCampaignName("");
		setIsChanged({
			name: false,
			type: false,
			display_ahead: false,
			start_date: false,
			end_date: false,
		});
		setFormError({
			name: "",
			type: "",
			start_date: "",
			end_date: "",
			wrong_date: "",
			product_ids: "",
		});
	};

	const handleSubmitCreateNewCampaign = () => {
		if (!validateForm("campaign", "create")) return;
		setIsSubmitted(true);
		props.createdAminSaleCampaign({
			name: campaignName,
			type: promotionType,
			icon: icon,
			mobile_banner: banner?.mobile,
			web_banner: banner?.web,
		});
		let timeout = setTimeout(() => {
			handleToggleCrateNewCampaign();
			setIsSubmitted(false);
		}, 500);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handleDeleteCampaign = (campaign) => {
		if (campaign?.is_disabled === 0) {
			window.alert("Cannot Delete. The campaign is activating.");
			return;
		}
		if (
			!window.confirm(`Do you wish to delete the campaign - "${campaign.name}"?`)
		) {
			return;
		}
		props.deleteAdminSaleCampaign({ campaign_id: campaign.campaign_id });
	};

	const handleToggleCreateCampaignProducts = () => {
		setCreateProductCampaignMode(true);
		setStartDate(null);
		setEndDate(null);
	};

	const handleSubmitCreateCampaignProducts = () => {
		if (!validateForm("products", "create")) return;
		setIsSubmitted(true);
		const body = {
			campaign_id: campaign?.campaign_id,
			display_ahead: displayAhead,
			product_ids: productIDS,
			start_date: startDate,
			end_date: endDate,
		};
		props.createAdminProductsSaleCampaign(body);
		let timeout = setTimeout(() => {
			setCreateProductCampaignMode(false);
			setShowEditCampaignFormModal(false);
			setCampaign(
				props?.campaigns.find(
					(item) => parseInt(item?.campaign_id) === parseInt(campaign?.campaign_id)
				)
			);
			setIsChanged({
				name: false,
				display_ahead: false,
				start_date: false,
				end_date: false,
			});
			setFormError({
				name: "",
				start_date: "",
				end_date: "",
				wrong_date: "",
				product_ids: "",
			});
			setProductIDs([]);
			setIsSubmitted(false);
		}, 500);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handleToggleAddProducts = () => {
		setAddProductMode((prev) => !prev);
		setCampaignPage(1);
		setPromoPage(1);
		setProductIDs([]);
		props.getAdminProductsSaleCampaign({
			campaign_id: campaign?.campaign_id,
			page: campaignPage,
			limit: 10,
		});
	};

	const handleSubmitAddBulkProducts = () => {
		props.addAdminProductsSaleCampaign({
			campaign_id: campaign?.campaign_id,
			product_ids: productIDS,
			fetchPromo: true,
			sub_cat_id: 187,
			page: 1,
			limit: 10,
			start_date: startDate,
			end_date: endDate,
		});
		let timeout = setTimeout(() => {
			setPromoPage(1);
			setProductIDs([]);
		}, 1000);
		return () => {
			clearTimeout(timeout);
		};
	};

	// handle search
	const handleSearchProductsCampaign = useCallback(
		debounce((e) => {
			setSearch(e?.target?.value);
		}, 500),
		[]
	);

	const handleSearchProductPromo = useCallback(
		debounce((e) => {
			setSearchPromo(e?.target?.value);
		}, 500),
		[]
	);

	//handle selected each product
	const handleSelected = (value) => {
		let tmp = [...productIDS];
		if (productIDS.filter((id) => parseInt(id) === parseInt(value)).length > 0) {
			setProductIDs(tmp.filter((id) => parseInt(id) !== parseInt(value)));
		} else {
			tmp.push(value);
			setProductIDs(tmp);
		}
	};

	//handle selected All products
	const handleSelectedAllProducts = (type) => {
		let propsProducts =
			type === "promo" ? props.promo_products : props.campaign_products;

		if (propsProducts && propsProducts?.list?.length) {
			if (productIDS.length) {
				const isSelectedAll = propsProducts?.list.every((id) =>
					productIDS.includes(id.item_id)
				);
				const isSelectedSome = propsProducts?.list.some((id) =>
					productIDS.includes(id.item_id)
				);

				if (isSelectedAll || isSelectedSome) {
					const productsID = propsProducts?.list.map((product) => product.item_id);
					const selectedAllProductsId = productIDS.filter(
						(id) => !productsID.includes(id)
					);
					setProductIDs(selectedAllProductsId);
				} else {
					const selectedAllProductsId = propsProducts?.list.map(
						(product) => product.item_id
					);
					setProductIDs((prevState) => [...prevState, ...selectedAllProductsId]);
				}
			} else {
				const selectedAllProductsId = propsProducts?.list.map(
					(product) => product.item_id
				);
				setProductIDs((prevState) => [...prevState, ...selectedAllProductsId]);
			}
		}
	};

	//render change check form selectedAll show
	const renderSelectAllCheckBox = (type) => {
		let propsProducts =
			type === "promo" ? props?.promo_products : props?.campaign_products;

		const isDisabled =
			!addProductMode &&
			(!(startDate && endDate) || moment(endDate).isSameOrBefore(startDate));

		if (productIDS.length && propsProducts?.list.length) {
			const isSelectedAll = propsProducts?.list.every((id) =>
				productIDS.includes(id.item_id)
			);
			const isSelectedSome = propsProducts?.list.some((id) =>
				productIDS.includes(id.item_id)
			);

			if (isSelectedAll) {
				return (
					<Checkbox
						checked={isSelectedAll}
						onChange={() => handleSelectedAllProducts(type)}
						color="primary"
						className="selectAllCheckBox"
						inputProps={{ "aria-label": "secondary checkbox" }}
						disabled={isDisabled}
					/>
				);
			} else if (isSelectedSome) {
				return (
					<Checkbox
						checked={isSelectedSome}
						indeterminate
						color="primary"
						onChange={() => handleSelectedAllProducts(type)}
						inputProps={{ "aria-label": "indeterminate checkbox" }}
						disabled={isDisabled}
					/>
				);
			} else {
				return (
					<Checkbox
						checked={false}
						onChange={() => handleSelectedAllProducts(type)}
						color="primary"
						className="selectAllCheckBox"
						inputProps={{ "aria-label": "secondary checkbox" }}
						disabled={isDisabled}
					/>
				);
			}
		} else {
			return (
				<Checkbox
					checked={false}
					onChange={() => handleSelectedAllProducts(type)}
					color="primary"
					inputProps={{ "aria-label": "secondary checkbox" }}
					disabled={isDisabled}
				/>
			);
		}
	};

	const isCampaignProduct = (itemId) => {
		return props.campaign_products?.list?.some(
			(item) => parseInt(item?.item_id) === parseInt(itemId)
		);
	};

	const isAddedAllToCampaign = () => {
		return props?.promo_products?.list?.every((promo_item) =>
			props?.campaign_products?.list
				?.map((campaign_item) => campaign_item.item_id)
				.includes(promo_item.item_id)
		);
	};

	useEffect(() => {
		let query = { active: filterActive, status: filterStatus };
		props.getAllAdminSaleCampaigns(query);
	}, [filterActive, filterStatus]);

	useEffect(() => {
		if (!campaign?.campaign_id) return;
		props.getAdminProductsSaleCampaign({
			campaign_id: campaign?.campaign_id,
			search: search?.trim(),
			page: campaignPage,
			limit: 10,
		});
	}, [campaign?.campaign_id, search, campaignPage]);

	useEffect(() => {
		if (addProductMode || createProductsCampaignMode) {
			props.getPromotionProducts({
				sub_cat_id: 187,
				search: searchPromo?.trim(),
				page: promoPage,
				limit: 10,
				start_date: startDate,
				end_date: endDate,
				campaign_id: campaign?.campaign_id ?? null,
			});
		}
	}, [
		searchPromo,
		promoPage,
		startDate,
		endDate,
		addProductMode,
		createProductsCampaignMode,
	]);

	let content = null;
	if (props?.campaign_products?.list?.length) {
		content = props?.campaign_products?.list?.map((product, key) => (
			<tr key={key}>
				<td className="text-center">
					<Checkbox
						checked={productIDS.includes(product.item_id)}
						onChange={() => handleSelected(product.item_id)}
						color="primary"
						inputProps={{ "aria-label": "secondary checkbox" }}
					/>
				</td>
				<td
					onClick={(e) => {
						handleShowImageOpen(product.default_image_url);
					}}
					style={logoWrapper}
				>
					<img
						src={
							product.default_image_url ??
							require("../../assets/images/delishop-favicons.png")
						}
						alt="img"
						style={logo}
					/>
				</td>
				<td>{product ? product.item_id : ""}</td>
				<td>{product ? product.product_code : ""}</td>
				<td>{product ? product.name : ""}</td>
				<td>
					{(product && product?.list_brands && product?.list_brands.length)
						? product?.list_brands[0]?.brand_id
						: product?.list_brand
							? product?.list_brand?.name
							: ""}
				</td>
				<td>
					<Button
						className="w-100"
						variant="danger"
						size="sm"
						disabled={productIDS.length}
						onClick={() => handleDeleteCampaignProduct([product?.item_id])}
					>
						<Delete />
					</Button>
				</td>
			</tr>
		));
	} else {
		if (props.loading) {
			content = (
				<tr>
					<td colSpan={7} className="text-center">
						<Spinner animation="border" />
					</td>
				</tr>
			);
		} else {
			content = (
				<tr>
					<td colSpan={7} className="text-center">
						Products not found :(
					</td>
				</tr>
			);
		}
	}

	let promoContent = null;
	if (props?.promo_products?.list?.length) {
		promoContent = props?.promo_products?.list?.map((product, key) => (
			<tr key={key}>
				{/* {addProductMode ? null : ( */}
				<td className="text-center">
					<Checkbox
						disabled={
							!addProductMode &&
							(!(startDate && endDate) || moment(endDate).isSameOrBefore(startDate))
						}
						checked={productIDS.includes(product.item_id)}
						onChange={() => handleSelected(product.item_id)}
						color="primary"
						inputProps={{ "aria-label": "secondary checkbox" }}
					/>
				</td>
				{/* )} */}
				<td
					onClick={(e) => {
						handleShowImageOpen(product.default_image_url);
					}}
					style={logoWrapper}
				>
					<img
						src={
							product.default_image_url ??
							require("../../assets/images/delishop-favicons.png")
						}
						alt="img"
						style={logo}
					/>
				</td>
				<td>{product ? product.item_id : ""}</td>
				<td>{product ? product.product_code : ""}</td>
				<td>{product ? product.name : ""}</td>
				<td>
					{(product && product?.list_brands && product?.list_brands.length)
						? product?.list_brands[0]?.brand_id
						: product?.list_brand
							? product?.list_brand?.name
							: ""}
				</td>
				{addProductMode ? (
					<td>
						{isCampaignProduct(product.item_id) ? (
							<Button
								className="w-100"
								variant="danger"
								size="sm"
								onClick={() => handleDeleteCampaignProduct([product.item_id])}
							>
								<Delete />
							</Button>
						) : (
							<Button
								className="w-100"
								size="sm"
								disabled={productIDS.length}
								onClick={() => handleAddCampaignProduct([product.item_id])}
							>
								<AddCircle />
							</Button>
						)}
					</td>
				) : null}
			</tr>
		));
	} else {
		if (props.loading) {
			promoContent = (
				<tr>
					<td colSpan={7} className="text-center">
						<Spinner animation="border" />
					</td>
				</tr>
			);
		} else {
			promoContent = (
				<tr>
					<td colSpan={7} className="text-center">
						{props?.promo_products?.list?.length >= 1 && isAddedAllToCampaign()
							? "All product promotions have been added to promotion campaign."
							: "Products not found :("}
					</td>
				</tr>
			);
		}
	}

	return (
		<HelpPageWrapper>
			<CardContainer>
				<Row>
					<Col xs={12} md={6}>
						<h4 className="mb-2">Sale Promotion Campaigns</h4>
					</Col>
					<Col xs={12} md={6}>
						<Button
							className="d-block ml-auto mb-2"
							onClick={handleToggleCrateNewCampaign}
						>
							<AddCircle /> Create New
						</Button>
					</Col>
					<Col xs={12}>
						<Row>
							<Col xs={6} lg={3}>
								<Form.Group controlId="formCampaignFilterActive">
									<Form.Control
										as="select"
										onChange={(e) => {
											handleChangeCampaignFilter(e, "active");
										}}
									>
										{activeFilters.map((filter) => {
											return (
												<option key={filter?.value} value={filter?.value}>
													{filter.label}
												</option>
											);
										})}
									</Form.Control>
								</Form.Group>
							</Col>
							<Col xs={6} lg={3}>
								<Form.Group controlId="formCampaignFilterActive">
									<Form.Control
										as="select"
										onChange={(e) => {
											handleChangeCampaignFilter(e, "status");
										}}
									>
										{statusFilters.map((filter) => {
											return (
												<option key={filter?.value} value={filter?.value}>
													{filter.label}
												</option>
											);
										})}
									</Form.Control>
								</Form.Group>
							</Col>
						</Row>
					</Col>
				</Row>
				<TableBodyWidth>
					<Table striped bordered hover responsive>
						<thead>
							<tr>
								<th>ID</th>
								<th>Name</th>
								<th>Ref ID</th>
								<th>Due Date</th>
								<th>Status</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{props?.campaigns.length ? (
								props?.campaigns?.map((campaign) => {
									return (
										<tr key={campaign?.campaign_id}>
											<td>{campaign?.campaign_id}</td>
											<td>{campaign.name}</td>
											<td>{campaign.name_ref_id}</td>

											<td>
												{campaign?.sale_promotion_campaign_product
													? campaign?.sale_promotion_campaign_product?.start_date +
													  " - " +
													  campaign?.sale_promotion_campaign_product?.end_date
													: "N/A"}
											</td>
											<td>
												{campaign?.sale_promotion_campaign_product ? (
													moment(
														campaign?.sale_promotion_campaign_product?.end_date
													).isSameOrBefore(moment()) ? (
														<span className="text-danger">Expired</span>
													) : (
														<span className="text-primary">
															Valid{!campaign.is_disabled ? " (active)" : ""}
														</span>
													)
												) : (
													"N/A"
												)}
											</td>
											<td>
												<div
													style={{
														width: "100%",
														height: "100%",
														display: "flex",
														justifyContent: "space-between",
														gap: "0.25rem",
													}}
												>
													{moment(
														campaign?.sale_promotion_campaign_product?.end_date
													).isSameOrBefore(moment()) ? null : campaign.is_disabled ? (
														<Button
															className="w-100"
															variant="secondary"
															size="sm"
															onClick={() => handleEnableCampaign(campaign?.campaign_id, 0)}
														>
															<VisibilityOff />
														</Button>
													) : (
														<Button
															variant="primary"
															size="sm"
															className="w-100"
															onClick={() => handleEnableCampaign(campaign?.campaign_id, 1)}
														>
															<Visibility />
														</Button>
													)}
													{campaign?.sale_promotion_campaign_product &&
													moment(
														campaign?.sale_promotion_campaign_product?.end_date
													).isSameOrBefore(moment()) ? null : (
														<Button
															className="w-100"
															size="sm"
															variant="info"
															onClick={() => handleOpenEditCampaignFormModal(campaign)}
														>
															<Edit />
														</Button>
													)}
													<Button
														variant="danger"
														size="sm"
														className="w-100"
														onClick={() => handleDeleteCampaign(campaign)}
													>
														<Delete />
													</Button>
												</div>
											</td>
										</tr>
									);
								})
							) : props?.loading ? (
								<tr>
									<td colSpan={6} className="text-center">
										<Spinner animation="border" variant="secondary" />
									</td>
								</tr>
							) : (
								<tr>
									<td colSpan={6} className="text-center">
										No Data
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</TableBodyWidth>
			</CardContainer>

			{/* Modal Add Campaign */}
			<Modal
				show={openNewCampaignModal}
				size="lg"
				onHide={handleToggleCrateNewCampaign}
			>
				<Modal.Header closeButton>
					<Modal.Title>Create Campaign</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col sm={6}>
							<Form.Group controlId="formCampaignName">
								<Form.Label className={formError.name ? "text-danger" : ""}>
									Name {formError.name}
								</Form.Label>
								<Form.Control
									placeholder="Enter campaign's name"
									value={campaignName}
									isInvalid={formError.name}
									isValid={!formError.name && campaignName}
									onChange={(e) => handleChangeCampaignName(e)}
								/>
							</Form.Group>
						</Col>
						<Col sm={6}>
							<Form.Group controlId="formCampaignPromotionType">
								<Form.Label className={formError.type ? "text-danger" : ""}>
									Promotion type {formError.type ?? ""}
								</Form.Label>
								<Form.Control
									as="select"
									isInvalid={formError.type}
									isValid={isChanged.type && promotionType}
									value={promotionType}
									onChange={(e) => handleChangePromotionType(e)}
								>
									{promotionTypes?.map((type) => {
										return (
											<option key={type.value} value={type.value}>
												{type.label}
											</option>
										);
									})}
								</Form.Control>
							</Form.Group>
						</Col>
						<Col sm={12}>
							<Row>
								<Col xs={12}>
									<Form.Group controlId="formCamIcon">
										<Form.Label>Campaign Icon</Form.Label>
										<Form.File
											ref={_campaignIconRef}
											label={icon || "Select file"}
											//accept="image/png, image/gif, image/jpeg"
											lang="en"
											className="mb-2"
											custom
											onChange={() => handleChangeBanner("icon")}
										/>
										{bannerLoading?.icon ? (
											<div
												style={{
													minHeight: "200px",
													width: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Spinner animation="border" variant="secondary" />
											</div>
										) : icon ? (
											<Image
												src={icon}
												rounded
												style={{
													width: "200px",
													height: "200px",
													objectFit: "contain",
												}}
											/>
										) : (
											<div
												style={{
													minHeight: "200px",
													width: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Photo />
											</div>
										)}
									</Form.Group>
								</Col>
								<Col xs={12}>
									<Form.Group controlId="formMobileBanner">
										<Form.Label>Mobile's banner</Form.Label>
										<Form.File
											ref={_mobileBannerFileRef}
											label={banner?.mobile || "Select file"}
											//accept="image/png, image/gif, image/jpeg"
											lang="en"
											className="mb-2"
											custom
											onChange={() => handleChangeBanner("mobile")}
										/>
										{bannerLoading?.mobile ? (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Spinner animation="border" variant="secondary" />
											</div>
										) : banner?.mobile ? (
											<Image
												src={banner?.mobile}
												rounded
												style={{
													width: "100%",
													height: "auto",
													objectFit: "contain",
												}}
											/>
										) : (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Photo />
											</div>
										)}
									</Form.Group>
								</Col>
								<Col xs={12}>
									<Form.Group controlId="formWebBanner">
										<Form.Label>Website's banner</Form.Label>
										<Form.File
											ref={_webBannerFileRef}
											label={banner?.web || "Select file"}
											//accept="image/png, image/gif, image/jpeg"
											lang="en"
											className="mb-2"
											custom
											onChange={() => handleChangeBanner("web")}
										/>
										{bannerLoading?.web ? (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Spinner animation="border" variant="secondary" />
											</div>
										) : banner?.web ? (
											<Image
												src={banner?.web}
												rounded
												style={{
													width: "100%",
													height: "auto",
													objectFit: "contain",
												}}
											/>
										) : (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Photo />
											</div>
										)}
									</Form.Group>
								</Col>
							</Row>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button disabled={isSubmitted} onClick={handleSubmitCreateNewCampaign}>
						Create
					</Button>
				</Modal.Footer>
			</Modal>

			{/* Add Products Modal  */}
			<Modal
				show={showEditCampaignFormModal}
				onHide={handleCloseEditCampaignFormModal}
				size="xl"
			>
				<Modal.Header closeButton>
					<Modal.Title>{campaign?.name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Tabs defaultActiveKey={"infos"} justify>
						<Tab eventKey={"infos"} title="Infos" className="pt-2">
							{campaign?.sale_promotion_campaign_product ? (
								<>
									<Row>
										<Col xs={12}>
											<Row>
												<Col sm={6}>
													<Row>
														<Col xs={12} md={6}>
															<Form.Group controlId="formCampaignName">
																<Form.Label className={formError.name ? "text-danger" : ""}>
																	Name {formError.name ?? ""}
																</Form.Label>
																<Form.Control
																	disabled={!infosEditMode}
																	value={campaignName}
																	isInvalid={formError.name}
																	isValid={isChanged.name && campaignName}
																	onChange={(e) => handleChangeCampaignName(e)}
																/>
															</Form.Group>
														</Col>
														<Col xs={12} md={6}>
															<Form.Group controlId="formCampaignPromotionType">
																<Form.Label className={formError.type ? "text-danger" : ""}>
																	Promotion type {formError.type ?? ""}
																</Form.Label>
																{/* <Form.Control disabled value={campaignRefId} /> */}
																<Form.Control
																	as="select"
																	disabled={!infosEditMode}
																	isInvalid={formError.type}
																	isValid={isChanged.type && promotionType}
																	value={promotionType}
																	onChange={(e) => handleChangePromotionType(e)}
																>
																	{promotionTypes?.map((type) => {
																		return (
																			<option key={type.value} value={type.value}>
																				{type.label}
																			</option>
																		);
																	})}
																</Form.Control>
															</Form.Group>
														</Col>
													</Row>
												</Col>
												<Col sm={6}>
													<Form.Group controlId="formCampaignDisplayAhead">
														<Form.Label
															className={formError.display_ahead ? "text-danger" : ""}
														>
															Display Ahead {formError.display_ahead ?? ""}
														</Form.Label>
														<Form.Control
															type="number"
															placeholder="Numbers of day"
															min="1"
															disabled={!infosEditMode}
															value={displayAhead}
															isInvalid={formError.display_ahead}
															isValid={isChanged.display_ahead && displayAhead}
															onChange={(e) => handleChangeDisplayAhead(e)}
														/>
													</Form.Group>
												</Col>
											</Row>
										</Col>
										<Col xs={12}>
											<Row>
												<Col sm={6}>
													<Form.Group controlId="formCampaignStartDate">
														<Form.Label
															className={
																!startDate || formError.start_date ? "text-danger" : ""
															}
														>
															Start Date{" "}
															{!startDate || formError.start_date
																? formError.start_date
																	? formError.start_date
																	: "is required."
																: ""}
														</Form.Label>
														<Form.Control
															type="datetime-local"
															disabled={!infosEditMode}
															value={startDate}
															isInvalid={!startDate || formError.start_date}
															isValid={isChanged.start_date && startDate}
															onChange={(e) => handleChangeDate(e, "start")}
														/>
													</Form.Group>
												</Col>
												<Col sm={6}>
													<Form.Group controlId="formCampaignEndDate">
														<Form.Label
															className={
																!endDate ||
																formError.end_date ||
																moment(endDate).isSameOrBefore(moment(startDate))
																	? "text-danger"
																	: ""
															}
														>
															End Date{" "}
															{!endDate || formError.end_date
																? formError.end_date
																	? formError.end_date
																	: "is required."
																: moment(endDate).isSameOrBefore(moment(startDate))
																? "must be greater than Start Date."
																: ""}
														</Form.Label>
														<Form.Control
															type="datetime-local"
															disabled={!infosEditMode}
															value={endDate}
															isInvalid={
																!endDate ||
																formError.end_date ||
																moment(endDate).isSameOrBefore(moment(startDate))
															}
															isValid={
																isChanged.end_date &&
																endDate &&
																moment(endDate).isSameOrAfter(moment(startDate))
															}
															onChange={(e) => handleChangeDate(e, "end")}
														/>
													</Form.Group>
												</Col>
											</Row>
										</Col>
										<Col xs={12}>
											<Row>
												<Col xs={12}>
													{infosEditMode ? (
														<div className="d-flex justify-content-end">
															<Button
																className="mr-2"
																variant="secondary"
																onClick={() => handleCancelEdit("infos")}
															>
																Cancel
															</Button>
															<Button onClick={() => handleSubmitUpdateCampaign("infos")}>
																Submit
															</Button>
														</div>
													) : (
														<Button
															className="d-block ml-auto"
															variant="info"
															onClick={() => setInfosEditMode(true)}
														>
															Edit
														</Button>
													)}
												</Col>
											</Row>
										</Col>
									</Row>
									<Card className="p-2 mt-2">
										<Card.Header style={{ padding: "0.5rem" }}>
											<Row>
												<Col xs={12} lg={4}>
													{addProductMode ? (
														<Form.Control
															type="search"
															placeholder="Search products (item_id, sku, name), brand (name)"
															onChange={(e) => handleSearchProductPromo(e)}
														/>
													) : (
														<Form.Control
															type="search"
															placeholder="Search products (item_id, sku, name), brand (name)"
															onChange={(e) => handleSearchProductsCampaign(e)}
														/>
													)}
												</Col>
												<Col xs={12} lg={4} className="my-2 my-lg-0">
													{addProductMode ? (
														<>
															<Button
																variant="primary"
																className="float-right float-lg-left"
																onClick={handleSubmitAddBulkProducts}
																disabled={isAddedAllToCampaign() || !productIDS.length}
															>
																Submit
															</Button>
															<Button
																variant="secondary"
																className="float-right float-lg-left mx-2"
																onClick={handleToggleAddProducts}
															>
																Close
															</Button>
														</>
													) : (
														<>
															<Button
																className="float-right float-md-left"
																onClick={handleToggleAddProducts}
															>
																Add Products
															</Button>
															<Button
																variant="danger"
																disabled={!productIDS.length}
																className="float-right float-md-left mx-2"
																onClick={() => {
																	if (
																		!window.confirm(
																			"Are you sure you want to delete all the campaign products?"
																		)
																	)
																		return;
																	handleDeleteCampaignProduct(productIDS);
																}}
															>
																Bulk Delete
															</Button>
														</>
													)}
												</Col>
												<Col xs={12} lg={4}>
													{addProductMode ? (
														<Pagination className="float-right">
															<Pagination.First
																onClick={() => handleChangePromoPage("first")}
																disabled={
																	props?.promo_products?.list?.length === 0 || promoPage === 1
																}
															/>
															<Pagination.Prev
																onClick={() => handleChangePromoPage("back")}
																disabled={
																	props?.promo_products?.list?.length === 0 || promoPage === 1
																}
															/>
															<Pagination.Item disabled>
																{props?.promo_products?.total_page > 0
																	? promoPage + " / " + props?.promo_products.total_page
																	: "0 / 0"}
															</Pagination.Item>
															<Pagination.Next
																onClick={() => handleChangePromoPage("next")}
																disabled={
																	props?.promo_products?.list?.length === 0 ||
																	promoPage === props?.promo_products?.total_page ||
																	!props?.promo_products?.total_page
																}
															/>
															<Pagination.Last
																onClick={() => handleChangePromoPage("last")}
																disabled={
																	props?.products?.list?.length === 0 ||
																	promoPage === props?.promo_products?.total_page ||
																	!props.promo_products?.total_page
																}
															/>
														</Pagination>
													) : (
														<Pagination className="float-right">
															<Pagination.First
																onClick={() => handleChangeCampaignPage("first")}
																disabled={
																	props?.campaign_products?.list?.length === 0 ||
																	campaignPage === 1
																}
															/>
															<Pagination.Prev
																onClick={() => handleChangeCampaignPage("back")}
																disabled={
																	props?.campaign_products?.list?.length === 0 ||
																	campaignPage === 1
																}
															/>
															<Pagination.Item disabled>
																{props?.campaign_products?.totalPages > 0
																	? campaignPage + " / " + props?.campaign_products.totalPages
																	: "0 / 0"}
															</Pagination.Item>
															<Pagination.Next
																onClick={() => handleChangeCampaignPage("next")}
																disabled={
																	props?.campaign_products?.list?.length === 0 ||
																	campaignPage === props?.campaign_products?.totalPages ||
																	!props?.campaign_products?.totalPages
																}
															/>
															<Pagination.Last
																onClick={() => handleChangeCampaignPage("last")}
																disabled={
																	props?.products?.list?.length === 0 ||
																	campaignPage === props?.campaign_products?.totalPages ||
																	!props.campaign_products?.totalPages
																}
															/>
														</Pagination>
													)}
												</Col>
											</Row>
										</Card.Header>
										<Card.Body
											style={{
												maxHeight: `${window.innerHeight - 270}px`,
												minHeight: `${window.innerHeight - 270}px`,
												overflow: "auto",
												padding: "0.5rem",
											}}
										>
											{addProductMode ? (
												<TableBodyWidth
													className="table-responsive"
													style={{ overflowY: "hidden" }}
												>
													<Table striped bordered hover>
														<thead>
															<tr>
																<th>{renderSelectAllCheckBox("promo")}</th>
																<th>Image</th>
																<th>ID</th>
																<th>SKU</th>
																<th>Product Name</th>
																<th>Brand Name</th>
																<th>Action</th>
															</tr>
														</thead>
														<tbody>{promoContent}</tbody>
													</Table>
												</TableBodyWidth>
											) : (
												<TableBodyWidth
													className="table-responsive"
													style={{ overflowY: "hidden" }}
												>
													<Table striped bordered hover>
														<thead>
															<tr>
																<th>{renderSelectAllCheckBox("campaign")}</th>
																<th>Image</th>
																<th>ID</th>
																<th>SKU</th>
																<th>Product Name</th>
																<th>Brand Name</th>
																<th>Action</th>
															</tr>
														</thead>
														<tbody>{content}</tbody>
													</Table>
												</TableBodyWidth>
											)}
										</Card.Body>
										<Card.Footer className="p-0"/>
									</Card>
								</>
							) : !createProductsCampaignMode &&
							  !campaign?.sale_promotion_campaign_product ? (
								<Row>
									<Col className="p-5">
										<Button onClick={handleToggleCreateCampaignProducts}>
											<AddCircle /> Create
										</Button>
									</Col>
								</Row>
							) : (
								<>
									<Row>
										<Col xs={12}>
											<Row>
												<Col sm={6}>
													<Form.Group controlId="formCampaignStartDate">
														<Form.Label
															className={
																!startDate && formError.start_date ? "text-danger" : ""
															}
														>
															Start Date{" "}
															{!startDate && formError.start_date ? formError.start_date : ""}
														</Form.Label>
														<Form.Control
															type="datetime-local"
															value={startDate}
															disabled={isSubmitted}
															isInvalid={!startDate && formError.start_date}
															isValid={startDate}
															onChange={(e) => handleChangeDate(e, "start")}
														/>
													</Form.Group>
												</Col>
												<Col sm={6}>
													<Form.Group controlId="formCampaignEndDate">
														<Form.Label
															className={
																(formError.end_date && !endDate) ||
																moment(endDate).isSameOrBefore(moment(startDate))
																	? "text-danger"
																	: ""
															}
														>
															End Date{" "}
															{!endDate && formError.end_date
																? formError.end_date
																: moment(endDate).isSameOrBefore(moment(startDate))
																? "must be greater than Start Date."
																: ""}
														</Form.Label>
														<Form.Control
															type="datetime-local"
															value={endDate}
															disabled={isSubmitted}
															isInvalid={
																(!endDate && formError.end_date) ||
																moment(endDate).isSameOrBefore(moment(startDate))
															}
															isValid={
																endDate && moment(endDate).isSameOrAfter(moment(startDate))
															}
															onChange={(e) => handleChangeDate(e, "end")}
														/>
													</Form.Group>
												</Col>
											</Row>
										</Col>
										<Col>
											<Row>
												<Col sm={6}>
													<Form.Group controlId="formCampaignDisplayAhead">
														<Form.Label
															className={formError.display_ahead ? "text-danger" : ""}
														>
															Display Ahead {formError.display_ahead ?? ""}
														</Form.Label>
														<Form.Control
															type="number"
															min="1"
															placeholder="Numbers of day"
															value={displayAhead}
															disabled={isSubmitted}
															isInvalid={formError.display_ahead}
															isValid={isChanged.display_ahead && displayAhead}
															onChange={(e) => handleChangeDisplayAhead(e)}
														/>
													</Form.Group>
												</Col>
											</Row>
										</Col>
									</Row>
									<Card className="p-2">
										<Card.Header style={{ padding: "0.5rem" }}>
											<Row>
												<Col xs={12} md={6}>
													<Form.Control
														type="search"
														placeholder="Search products (item_id, sku, name), brand (name)"
														onChange={(e) => handleSearchProductPromo(e)}
													/>
												</Col>
												<Col xs={12} md={6}>
													<Pagination className="float-right">
														<Pagination.First
															onClick={() => handleChangePromoPage("first")}
															disabled={
																props?.promo_products?.list?.length === 0 || promoPage === 1
															}
														/>
														<Pagination.Prev
															onClick={() => handleChangePromoPage("back")}
															disabled={
																props?.promo_products?.list?.length === 0 || promoPage === 1
															}
														/>
														<Pagination.Item disabled>
															{props?.promo_products?.total_page > 0
																? promoPage + " / " + props?.promo_products.total_page
																: "0 / 0"}
														</Pagination.Item>
														<Pagination.Next
															onClick={() => handleChangePromoPage("next")}
															disabled={
																props?.promo_products?.list?.length === 0 ||
																promoPage === props?.promo_products?.total_page ||
																!props?.promo_products?.total_page
															}
														/>
														<Pagination.Last
															onClick={() => handleChangePromoPage("last")}
															disabled={
																props?.products?.list?.length === 0 ||
																promoPage === props?.promo_products?.total_page ||
																!props.promo_products?.total_page
															}
														/>
													</Pagination>
												</Col>
											</Row>
										</Card.Header>
										{formError.product_ids && !productIDS.length ? (
											<span className="d-block text-danger p-1">
												{formError.product_ids}
											</span>
										) : null}
										<Card.Body
											style={{
												maxHeight: `${window.innerHeight - 270}px`,
												minHeight: `${window.innerHeight - 270}px`,
												overflow: "auto",
												padding: "0.5rem",
											}}
										>
											<Table striped bordered hover responsive>
												<thead>
													<tr>
														<th>{renderSelectAllCheckBox("promo")}</th>
														<th>Image</th>
														<th>ID</th>
														<th>SKU</th>
														<th>Product Name</th>
														<th>Brand Name</th>
													</tr>
												</thead>
												<tbody>{promoContent}</tbody>
											</Table>
										</Card.Body>
										<Card.Footer style={{ padding: "0.5rem" }}>
											<Button
												className="d-block ml-auto"
												disabled={isSubmitted}
												onClick={handleSubmitCreateCampaignProducts}
											>
												Submit
											</Button>
										</Card.Footer>
									</Card>
								</>
							)}
						</Tab>
						<Tab eventKey={"banner"} title="Banner" className="pt-2">
							<Row>
								<Col xs={12}>
									<Form.Group controlId="formCamIcon">
										<Form.Label>Campaign Icon</Form.Label>
										<Form.File
											ref={_campaignIconRef}
											label={icon || "Select file"}
											//accept="image/png, image/gif, image/jpeg"
											lang="en"
											className="mb-2"
											custom
											disabled={!bannerEditMode}
											onChange={() => handleChangeBanner("icon")}
										/>
										{bannerLoading?.icon ? (
											<div
												style={{
													minHeight: "200px",
													width: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Spinner animation="border" variant="secondary" />
											</div>
										) : icon ? (
											<Image
												src={icon}
												rounded
												style={{
													width: "200px",
													height: "200px",
													objectFit: "contain",
												}}
											/>
										) : (
											<div
												style={{
													minHeight: "200px",
													width: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Photo />
											</div>
										)}
									</Form.Group>
								</Col>
								<Col xs={12}>
									<Form.Group controlId="formMobileBanner">
										<Form.Label>Mobile's banner</Form.Label>
										<Form.File
											ref={_mobileBannerFileRef}
											label={banner?.mobile || "Select file"}
											//accept="image/png, image/gif, image/jpeg"
											lang="en"
											className="mb-2"
											custom
											disabled={!bannerEditMode}
											onChange={() => handleChangeBanner("mobile")}
										/>
										{bannerLoading?.mobile ? (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Spinner animation="border" variant="secondary" />
											</div>
										) : banner?.mobile ? (
											<Image
												src={banner?.mobile}
												rounded
												style={{
													width: "100%",
													height: "auto",
													objectFit: "contain",
												}}
											/>
										) : (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Photo />
											</div>
										)}
									</Form.Group>
								</Col>
								<Col xs={12}>
									<Form.Group controlId="formWebBanner">
										<Form.Label>Website's banner</Form.Label>
										<Form.File
											ref={_webBannerFileRef}
											label={banner?.web || "Select file"}
											//accept="image/png, image/gif, image/jpeg"
											lang="en"
											className="mb-2"
											custom
											disabled={!bannerEditMode}
											onChange={() => handleChangeBanner("web")}
										/>
										{bannerLoading?.web ? (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Spinner animation="border" variant="secondary" />
											</div>
										) : banner?.web ? (
											<Image
												src={banner?.web}
												rounded
												style={{
													width: "100%",
													height: "auto",
													objectFit: "contain",
												}}
											/>
										) : (
											<div
												style={{
													minHeight: "200px",
													background: "#F5F7FA",
													display: "grid",
													placeItems: "center",
												}}
											>
												<Photo />
											</div>
										)}
									</Form.Group>
								</Col>
								<Col xs={12}>
									{bannerEditMode ? (
										<div className="d-flex justify-content-end">
											<Button
												className="mr-2"
												variant="secondary"
												onClick={() => handleCancelEdit("banner")}
											>
												Cancel
											</Button>
											<Button onClick={() => handleSubmitUpdateCampaign("banner")}>
												Submit
											</Button>
										</div>
									) : (
										<Button
											className="d-block ml-auto"
											variant="info"
											onClick={() => setBannerEditMode(true)}
										>
											Edit
										</Button>
									)}
								</Col>
							</Row>
						</Tab>
					</Tabs>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseEditCampaignFormModal}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>

			{/* image modal */}
			<Modal show={showImage} onHide={handleShowImageClose}>
				<Modal.Header closeButton>
					<Modal.Title>Image</Modal.Title>
				</Modal.Header>
				<Modal.Body
					style={{
						height: "400Px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<img
						alt="Product"
						src={imgUrl ?? require("../../assets/images/delishop-favicons.png")}
						style={{ width: "300px", height: "300px" }}
					/>
				</Modal.Body>
				<Modal.Footer />
			</Modal>
		</HelpPageWrapper>
	);
};

// style
const HelpPageWrapper = styled.div`
	background-color: #f7f7f7;
	position: relative;
	padding: 30px;
	min-height: 50vh;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@media (max-width: 989px) {
		padding-top: 70px;
	}
	& > div.row {
		background-color: #fff;
		padding: 30px 20px;
		border-radius: 10px;
		box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	}
`;

const CardContainer = styled.div`
	background-color: #fff;
	padding: 30px 20px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
`;

const TableBodyWidth = styled.div`
	table tr th {
		white-space: nowrap;
		width: initial;
		vertical-align: middle;
	}

	td {
		vertical-align: middle;
	}

	&.generalTypeSearchContent {
		td {
			vertical-align: middle;
		}
	}
`;

const logoWrapper = {
	display: "flex",
	// height: "80px",
	alignItems: "center",
};

const logo = {
	height: "60Px",
	width: "60Px",
	maxWidth: "60px",
	objectFit: "contain",
	display: "block",
	marginInline: "auto",
};

const mapStateToProps = (state) => {
	return {
		loading: state.globalReducer.loading,
		promo_products: state.dashboardReducer.promo_products,
		brands: state.dashboardReducer.brands,
		category: state.dashboardReducer.category,
		sub_category: state.dashboardReducer.sub_category,
		suppliers: state.dashboardReducer.suppliers,
		campaigns: state.dashboardReducer.campaigns,
		selected_campaign: state.dashboardReducer.selected_campaign,
		campaign_products: state.dashboardReducer.campaign_products,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getPromotionProducts: (data) => getPromotionProducts(data, dispatch),
		searchProduct: (data) => searchProduct(data, dispatch),
		getBrands: (data) => getBrands(data, dispatch),
		getCategory: (data) => getCategory(data, dispatch),
		getSubCategory: (data) => getSubCategory(data, dispatch),
		getSuppliers: (data) => getSuppliers(data, dispatch),
		getSubCategoryMap: (data) => getSubCategoryMap(data, dispatch),
		uploadPromotion: (data, handleToast) =>
			uploadPromotion(data, handleToast, dispatch),
		getAllAdminSaleCampaigns: (data) => getAllAdminSaleCampaigns(data, dispatch),
		createdAminSaleCampaign: (data) => createdAminSaleCampaign(data, dispatch),
		updateAdminSaleCampaign: (data) => updateAdminSaleCampaign(data, dispatch),
		deleteAdminSaleCampaign: (data) => deleteAdminSaleCampaign(data, dispatch),
		getAdminProductsSaleCampaign: (data, page, setPage) =>
			getAdminProductsSaleCampaign(data, page, setPage, dispatch),
		createAdminProductsSaleCampaign: (data) =>
			createAdminProductsSaleCampaign(data, dispatch),
		addAdminProductsSaleCampaign: (data) =>
			addAdminProductsSaleCampaign(data, dispatch),
		updateAdminProductsSaleCampaign: (data) =>
			updateAdminProductsSaleCampaign(data, dispatch),
		deleteAdminProductsSaleCampaign: (data) =>
			deleteAdminProductsSaleCampaign(data, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(PromotionCampaigns);
